<template>
  <div class="app-wrapper">
    <div class="vertical-layout">
      <div class="page-with-top-panel flex flex-col">
        <AppHeader />
        <div
          class="page-self flex-grow max-md:!pt-12 md:!pt-20"
          :class="{ 
            'overflow-hidden': route.name === 'dialogs',
            'max-md:pb-[58px]': userModule.authorized && !isDesktop && route.name !== 'index'
          }"
        >
          <!-- основной слот для страницы -->
          <slot></slot>
        </div>
      </div>
    </div>

    <UIOverlay :view-overlay="true" />
    <Teleport to="body">
      <ElDialog
        v-model="userModule.loginDialogVisible"
        width="492px"
        align-center
        class="wrapper-dialog !rounded-[24px] max-md:!max-w-[96%] !mx-auto max-md:!w-full"
      >
        <LoginScreen />
      </ElDialog>
    </Teleport>

    <!-- Debug панель для Telegram WebView -->
    <TelegramDebugPanel />

    <!-- Мобильное меню внизу экрана -->
    <AdvertiserMobileBottomNav />
  </div>
</template>
<script setup lang="ts">
  import { useUserStore } from "~/store/UserModule";
  import { onClickOutside } from "@vueuse/core";
  import AuthService from "@/services/AuthService";
  import { useScreenSize } from "~/helpers/isMobile";

  /* eslint-disable no-undef */
  const route = useRoute();
  const { isDesktop } = useScreenSize();

  const isOpenMenu = ref<boolean>(false);
  const target = ref(null);

  const userModule = useUserStore();
  const { name } = storeToRefs(userModule);

  const logout = () => {
    userModule.resetAuthKey();
    useCookie("accessTokenSJ").value = null;
    useCookie("authorizedP").value = null;
  };

  onMounted(() => {
    userModule.requestAuthKey();

  });

  if (import.meta.client) {
    watch(
      () => route.name,
      () => {
        nextTick(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        });
      }
    );

    onClickOutside(target, () => {
      isOpenMenu.value = false;
    });
  }
</script>

<style lang="scss" scoped>
  .app-wrapper {
    min-height: 100dvh;
  }

  .vertical-layout {
    display: flex;
    flex-direction: row;
    min-height: 100dvh;
  }

  .page-with-top-panel {
    flex-grow: 1;
    margin-left: 0;
    // Элемент строчного флекса по умолчанию не может стать уже своего содержимого:
    // широкая таблица в статье блога раздувала всю страницу за пределы экрана
    min-width: 0;
  }

  .horizontal-menu,
  .vertical-menu {
    background: $white;
  }

  .el-menu + .screen-wrapper {
    margin-left: 70px;

    @media (max-width: $small-width) {
      margin-left: 0;
    }
  }

  .horizontal-menu {
    @apply w-full px-5 z-50;
    height: 80px;

    &__aside {
      @apply h-full justify-end;

      &-user {
        width: fit-content;
        color: $light-gray;
        font-weight: 500;
      }

      &-notifications {
        width: fit-content;
        height: 100%;
        padding-left: clamp(20px, 2vw, 24px);
        padding-right: clamp(20px, 2vw, 24px);
        border-left: 1px solid rgba($main, 0.3);
        border-right: 1px solid rgba($main, 0.3);

        @media (max-width: $small-width) {
          border: none;
        }
      }
    }

    &__button {
      cursor: pointer;
      margin: 6px 0px;
      width: 36px;
      height: 36px;
      border-radius: 11px;
      border: 1px solid rgba($main, 0.2);
      flex-direction: column;
      gap: 5px;
      padding-left: 8px;
      padding-right: 8px;

      > div {
        width: 100%;
        height: 2px;
        background: $main;
        border-radius: 1px;
      }
    }
  }

  .horizontal-menu .horizontal-menu__button {
    display: none;
  }

  @media (max-width: $small-width) {
    .app-wrapper .vertical-menu.vertical-menu.el-menu--collapse {
      border-right: none;

      &:not(.horizontal-collapse-transition) {
        transform: translateX(-300px);
      }

      img {
        display: none;
      }
    }

    .horizontal-menu .horizontal-menu__button {
      display: flex;

      + a {
        z-index: 1;
      }
    }

    .horizontal-menu {
      justify-content: space-between;
    }

    @keyframes close {
      to {
        transform: translateX(-300px);
      }
    }

    .vertical-menu:not(.el-menu--collapse).v-leave-active {
      animation: close 0.4s ease-in;
    }
  }

  button.horizontal-menu__aside-enter {
    @apply px-3;
    max-width: min(35vw, 8rem);
  }
</style>
